<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>门店进销存管理</el-breadcrumb-item>
      <el-breadcrumb-item>采购汇总</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询用户 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-date-picker v-model="keywords.begintime" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" class="mr15"></el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="keywords.endtime" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" class="mr15"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
            <el-button type="success" @click="clickexcel()">导出</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->

        <el-table v-loading="loading" :data="dataList" :cell-style="{padding: '0'}" border stripe >
          <el-table-column prop="Jigouname" label="归属机构" min-width="15%"></el-table-column>
          <el-table-column prop="Chanping" label="产品采购金额" min-width="10%"></el-table-column>
          <el-table-column prop="Fuliao" label="辅料采购金额" min-width="10%"></el-table-column>
          <el-table-column prop="Bangongyongping" label="办公用品采购金额" min-width="10%"></el-table-column>
          <el-table-column prop="Gudingzichan" label="固定资产采购金额" min-width="10%"></el-table-column>
          <el-table-column prop="Qita" label="其他采购金额" min-width="10%"></el-table-column>
          <el-table-column prop="Huizong" label="汇总采购金额" min-width="10%"></el-table-column>
        </el-table>
      </el-tab-pane>
      <!-- 清单列表 end -->
    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  name: 'MyMenDianPurchaseSalesCaiGouHuiZong',
  data () {
    return {
      loading: false,
      activeName: 'first',
      dataList: [],
      // 查询
      keywords: {
        begintime: '',
        endtime: ''
      }
    }
  },
  mounted () {
    this.keywords.begintime = Vue.prototype.getFirstDay()
    this.keywords.endtime = Vue.prototype.getLastDay()
    this.apiMenDianPurchaseSalesCaiGouHuiZong()
  },
  methods: {
    clicksearch () {
      this.apiMenDianPurchaseSalesCaiGouHuiZong()
    },
    clickexcel () {
      this.apiExcelMenDianPurchaseSalesCaiGouHuiZong()
    },
    apiMenDianPurchaseSalesCaiGouHuiZong: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_MenDianPurchaseSalesCaiGouHuiZong, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apiExcelMenDianPurchaseSalesCaiGouHuiZong: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelMenDianPurchaseSalesCaiGouHuiZong, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.$confirm('是否跳转到文件管理，查看导出情况?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: true,
              type: 'warning'
            }).then(() => {
              that.$router.push({ path: '/FileManagementExcel' })
            })
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
